module.exports = __webpack_public_path__ + "static/media/gc-souvlaki.08848135.png";